<template>
  <div>
    <ckeditor
      :read-only="isReadOnly"
      :config="editorConfig"
      @ready="customHandler"
      :value="value"
      @input="$emit('input', $event)"
    ></ckeditor>
  </div>
</template>

<script>
let isInStage = window.location.href.includes("stage");
let isInLocal = window.location.href.includes("localhost");
let url;
if (isInStage || isInLocal) url = "https://stock-stage.chuen.com.tw";
else url = "https://stock.chuen.com.tw";
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorConfig: {
        height: 500,
        extraPlugins: ["colorbutton,colordialog", "uploadimage", "image2"],
        toolbarGroups: [
          {
            name: "basicstyles", //粗體、斜體、刪除線等
            groups: ["basicstyles"]
          },
          {
            name: "colors",
            groups: ["colors"]
          },
          {
            name: "insert", //表格、特殊符號等
            groups: ["insert"]
          },
          {
            name: "styles", //字體樣式、字體大小
            groups: ["styles"]
          }
          // {
          //   name: "links",//連結
          //   groups: ["links"]
          // },
          // {
          //   "name": "document",//程式碼
          //   "groups": ["mode"]
          // },
          // {
          //   name: "paragraph",//ul、ol
          //   groups: ["list", "blocks"]
          // }
        ],
        /************************
         * 按鈕 Underline,Strike,Subscript,Superscript 屬於 basicstyles;
         * 按鈕 Table,HorizontalRule,SpecialChar 屬於 insert;
         * 按鈕 Styles,Format 屬於 styles;
         ************************/
        removeButtons:
          "Underline,Strike,Subscript,Superscript,HorizontalRule,SpecialChar,Styles,Format",
        // filebrowserBrowseUrl: url + "/api/image",
        // filebrowserImageBrowseUrl: url + "/api/image"
        // filebrowserUploadUrl: url + "/api/image",
        filebrowserImageUploadUrl: url + "/api/image"
      }
    };
  },
  methods: {
    customHandler(ckeditor) {
      ckeditor.on("fileUploadRequest", evt => {
        var fileLoader = evt.data.fileLoader;
        var formData = new FormData();
        var xhr = fileLoader.xhr;
        formData.append("image", fileLoader.file, fileLoader.fileName);

        /**
         * 用按鈕上傳圖檔的 api url:
         *    https://stock-stage.chuen.com.tw/api/image
         * ctrl+v 上傳圖檔的 api url:
         *    https://stock-stage.chuen.com.tw/api/image&responseType=json
         **/
        if (fileLoader.uploadUrl.includes("&responseType=json")) {
          const currentUrl = location.origin;
          const stagingUrl = "https://stock-stage.chuen.com.tw";
          const productionUrl = "https://stock.chuen.com.tw";
          if (
            currentUrl.includes("-stage") ||
            currentUrl.includes("localhost:")
          ) {
            fileLoader.uploadUrl = `${stagingUrl}/api/image`;
          } else {
            fileLoader.uploadUrl = `${productionUrl}/api/image`;
          }
        }

        xhr.open("POST", fileLoader.uploadUrl, true);
        xhr.setRequestHeader(
          "Authorization",
          `Bearer ${this.$store.getters.loggedInInfo.api_token}`
        );
        xhr.send(formData);
        evt.stop();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
